import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  body?: any;
}

@Injectable({
  providedIn: "root",
})
export class AppHttpClient {
  private queries: { [endpoint: string]: Observable<any> } = {};

  public constructor(public http: HttpClient) { }

  public get<T>(endpoint: string, options?: IRequestOptions): Observable<T> {
    if (!this.queries[endpoint]) {
      this.queries[endpoint] = this.http.get<T>(`${environment.apiBaseUrl}/${endpoint}`, options).pipe(share());
    }

    return this.queries[endpoint];
  }

  public post<T>(endpoint: string, params: Object, options?: IRequestOptions): Observable<T> {
    return this.http.post<T>(`${environment.apiBaseUrl}/${endpoint}`, params, options);
  }

  public put<T>(endpoint: string, params: Object, options?: IRequestOptions): Observable<T> {
    return this.http.put<T>(`${environment.apiBaseUrl}/${endpoint}`, params, options);
  }

  public patch<T>(endpoint: string, params: Object, options?: IRequestOptions): Observable<T> {
    return this.http.patch<T>(`${environment.apiBaseUrl}/${endpoint}`, params, options);
  }

  public delete<T>(endpoint: string, options?: IRequestOptions): Observable<T> {
    return this.http.delete<T>(`${environment.apiBaseUrl}/${endpoint}`, options);
  }
}
